import React from "react";
import gh from '../Images/gh.jpg';
import Header from '../components/Header';

const AboutUs = () => {
  return (
    <div className="relative h-screen w-full">
      
      <Header/>
      {/* Background Image */}
      <img
        src={gh} 
        alt="Car"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Red Overlay Section */}
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="absolute right-0 top-0 h-full w-full md:w-1/2 bg-blue-500 bg-opacity-60 flex items-center justify-center px-6 py-12">
        <div className="max-w-xl text-white">
          <p className="text-lg text-white font-semibold mb-3">Know About Us</p>
          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
            We Make Your Drive <br /> Memorable.
          </h1>
          <p className="text-sm md:text-base leading-relaxed mb-6">
            Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Illum Iusto
            Minima Quo, Recusandae Perspiciatis Aspernatur, Rerum Tempora Vitae
            Aperiam Enim, Dicta Maxime? Eum Repellat Velit Perspiciatis Eligendi
            Rerum Voluptate Repellendus.
          </p>
          {/* <button   onClick={() => window.location.href = '/login'} className="bg-white text-blue-700 px-6 py-3 rounded-md font-semibold hover:bg-blue-100 transition duration-300">
            
            Discover More
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default AboutUs; 
